// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"49a4d9c6","73":"201433eb","82":"a507a4bb","111":"c5ad8c78","112":"6cdcc8ca","148":"24b520cd","280":"635fbac7","316":"5ac1a358","354":"881f4601","443":"26873ffa","490":"e9b8701c","554":"cad9bd9b","660":"4a876ebf","690":"11021f2e","742":"ac0d6c62","900":"260fbc6e"}[chunkId] + ".chunk.js";
};